import React from "react"
import { animateScroll } from "react-scroll"
import PageButtonsButton from "../components/pageButtonsButton"
import { useTranslation } from "gatsby-plugin-react-i18next"

const PageButtons = () => {
  const { t } = useTranslation()

  function scrollToTop() {
    animateScroll.scrollToTop()
  }

  return (
    <div className="fixed bottom-2 ml-6">
      <PageButtonsButton clickAction={scrollToTop}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="w-8 h-8"
        >
          <title>{t("to_top")}</title>
          <path
            fillRule="evenodd"
            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm.53 5.47a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.72-1.72v5.69a.75.75 0 001.5 0v-5.69l1.72 1.72a.75.75 0 101.06-1.06l-3-3z"
            clipRule="evenodd"
          />
        </svg>
      </PageButtonsButton>
    </div>
  )
}

export default PageButtons
